import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Config } from "../../Config";
import { toast } from "react-toastify";
import avatarEdit from "../../assets/images/profile/avatarEdit.svg";
import sendPhoto from "../../assets/images/sendProfilePhoto.png";
import cancellPhoto from "../../assets/images/cancellSendImage.png";
import Skeleton from "react-loading-skeleton";

const ChangeProfilePhoto = (props) => {
  const [profileImage, setProfileImage] = useState("");
  const [toggleButtons, setToggleButtons] = useState(false);
  const [showImageSkeleton, setShowImageSkeleton] = useState(true);
  const [sendImageLoading, setSendImageLoading] = useState(false);
  const [image, setImage] = useState("");
  const user = useSelector((state) => state.user);

  useEffect(() => {
    setProfileImage(props.data);
    if (props.data) {
      setShowImageSkeleton(false);
    }
  }, [props.data]);

  const changeProfileImageHandler = () => {
    let input = document.getElementById("profileImageSelectorInput");
    input.click();
  };
  const changeProfileInputHandler = async (e) => {
    if (!e.target.files[0].type.includes("image")) {
      toast.error("لطفا عکس انتخاب کنید");
      return;
    }
    let tag = document.getElementById("profileImageTag");
    let fr = new FileReader();
    fr.onload = function () {
      tag.src = fr.result;
    };
    fr.readAsDataURL(e.target.files[0]);
    setImage(await Config.convertToBase64(e.target.files[0]));
    setToggleButtons(true);
  };

  const sendProfilePhotoHandler = async () => {
    setSendImageLoading(true);
    fetch(Config.apiPath + "/account/changeProfile", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${user[0].token}`,
      },
      body: JSON.stringify({
        image: image,
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          setToggleButtons(false);
          setSendImageLoading(false);
          toast.success(result.messages[0]);
        } else {
          setSendImageLoading(false);
          toast.error(result.messages[0]);
        }
      });
  };
  const cancellProfilePhotoHandler = async () => {
    setToggleButtons(false);
    setImage("");
    let tag = document.getElementById("profileImageTag");
    tag.src = Config.imagePath + "/" + profileImage;
  };

  return (
    <>
      {!showImageSkeleton ? (
        <div className="profileAvatar">
          <img
            id="profileImageTag"
            // src={`${Config.imagePath}/${profileImage}`}
            src={`https://api.sadrayar.ir/${profileImage}`}
            // src={`https://api.kar30.ir/${profileImage}`}
            alt="پروفایل"
            className="profileImage"
            onClick={() => changeProfileImageHandler()}
          />
          {!toggleButtons && !sendImageLoading && (
            <div
              className="profileEditImageWrapper"
              onClick={() => {
                changeProfileImageHandler();
              }}
            >
              <img src={avatarEdit} alt="ویرایش" className="profileEditImage" />
            </div>
          )}
          {toggleButtons && !sendImageLoading && (
            <img
              src={sendPhoto}
              className="sendProfileImage"
              alt="اعمال"
              onClick={() => {
                sendProfilePhotoHandler();
              }}
            />
          )}
          {sendImageLoading && <div className="sendProfileImage sendSpinner" />}
          {toggleButtons && !sendImageLoading && (
            <img
              src={cancellPhoto}
              className="cancellProfileImage"
              alt="لغو"
              onClick={() => {
                cancellProfilePhotoHandler();
              }}
            />
          )}
        </div>
      ) : (
        <Skeleton
          containerClassName="profileAvatar"
          className="skeleton"
          circle
          highlightColor={Config.skeletonHighlightColor}
        />
      )}
      <input
        type="file"
        className="imageSelector"
        id="profileImageSelectorInput"
        onChange={(e) => changeProfileInputHandler(e)}
      />
    </>
  );
};

export default React.memo(ChangeProfilePhoto);
